import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {CommonUtils} from "../../utils/common";
import {VetClinic, VetDoctor, VImage} from "../../models/vet-clinic.model";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {ModalController} from "@ionic/angular";
import {FileService} from "../../providers/file.service";
import {Subscription} from "rxjs";
import {environment} from "../../../environments/environment";
import {AppStateService} from "../../providers/app-state.service";
import {VImageDropComponent} from "../v-image-drop/v-image-drop.component";
import {ReservationDhJson} from "../../models/reservation-dh-json.model";
import {ReservationDhJsonDashboard} from "../../models/reservationDhJsonDashboard.model";
import {QuillEditorComponent} from "ngx-quill";
import Quill from "quill";
import {DaySettings} from "../../models/day-settings.model";
import {VetineoVisitTypeMinutes} from "../../models/vet-doctor-vet-visit-type.model";
import {Partner} from "../../models/partner.model";
import {PartnerService} from "../../providers/partner.service";

@Component({
  selector: 'app-vet-doctor-data-editor',
  templateUrl: './vet-doctor-data-editor.component.html',
  styleUrls: ['./vet-doctor-data-editor.component.scss'],
})
export class VetDoctorDataEditorComponent implements OnInit, OnDestroy {

  @Input() vetClinicUUID: string;
  @Input() vetClinic: VetClinic;
  partner: Partner;
  @Input() vetcodeId: number;
  @Input() vetDoctor: VetDoctor;
  @Input() vetDoctorCount: number;
  @Input() isGeneralAdmin: boolean;
  @Input() isGeneralClientAdmin: boolean;
  @Output() vetDoctorEditedEmitter: EventEmitter<VetDoctor> = new EventEmitter<VetDoctor>();
  @Output() vetDoctorEditCanceledEmitter: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  @Output() hasUnsavedChangesEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() vetDoctorDeletedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('editor') editor: QuillEditorComponent;

  private hasUnsavedChanges: boolean = false;

  private isBusy: boolean = false;
  private isBusySub: Subscription;

  vetDocInfoGroup: FormGroup;
  editedVetDoctor: VetDoctor;

  private vImages: VImage[];
  private vImagesSub: Subscription;
  vetDocCp: VetDoctor;
  images: VImage[];
  minutesDefined: number[];
  defaultVisitMinutes: number;

  photoUpload: File;
  largePhotoUpload: File;
  progressiveReservationsDayHoursDashboardArray: ReservationDhJsonDashboard[];
  progressiveReservationsDayHoursJson: ReservationDhJson[];

  nightShiftLockHourDaysJsonDashboardArray: ReservationDhJsonDashboard[];
  phoneOnlyDays: ReservationDhJsonDashboard[];
  stationaryOnlyDays: ReservationDhJsonDashboard[];
  lockedReservationDayHoursJsonArray: ReservationDhJsonDashboard[];
  lockedReservationDayHoursJson: ReservationDhJson[];
  medicalProcedureCancellationTime: string;
  hoursDefined: string[] = [
    '12', '24', '36', '48', '72'
  ];

  phoneOnlyDaysToggle: boolean;
  stationaryOnlyDaysToggle: boolean;
  daysBlockedToggle: boolean;

  progressiveLockSettings: boolean = false;
  nightShiftLockSettings: boolean = false;
  private quill: Quill;
  private isHTMLToggle: boolean;
  private textAreaValue: string;
  private textAreaValueToSave: string;
  advancedDaysBlockedToggle: boolean = false;
  advancedLockedDayHoursArray: DaySettings[] = [];
  private partnerSub: Subscription;
  protected vetDoctorHadDefaultMinutes: boolean;
  protected startingDefaultMinutes: number;

  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private vetClinicService: VetClinicService,
    private modalController: ModalController,
    private fileService: FileService,
    private appStateService: AppStateService,
    private partnerService: PartnerService
  ) {
  }

  modules = {
    toolbar: {
      container: [
        ['bold'],        // toggled buttons
        [{'header': [4, false]}]
      ]
    }
  };

  ngOnInit() {
    if (this.vetClinic.partnerVClientId) {
      this.appStateService.updateIsBusySubject(true);
      this.partnerSub = this.partnerService.getByVetDoctorUUID(this.vetDoctor.uuid).subscribe(partner => {
        if (partner) {
          this.partner = partner;
        }
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.appStateService.updateIsBusySubject(false);
      });
    }

    this.minutesDefined = Object.values(VetineoVisitTypeMinutes)?.filter(value => typeof value === "number") as number[];

    this.vetDocCp = JSON.parse(JSON.stringify(this.vetDoctor));

    if (this.vetDoctor.progressiveReservations) {
      if (this.vetDoctor.progressiveReservationsDayHoursJson) {
        this.progressiveReservationsDayHoursJson = JSON.parse(this.vetDoctor.progressiveReservationsDayHoursJson)
      } else {
        this.progressiveReservationsDayHoursJson =
          [{"dayIdx": 1, "startTime": "00:00", "endTime": "00:00"},
            {"dayIdx": 2, "startTime": "00:00", "endTime": "00:00"},
            {"dayIdx": 3, "startTime": "00:00", "endTime": "00:00"},
            {"dayIdx": 4, "startTime": "00:00", "endTime": "00:00"},
            {"dayIdx": 5, "startTime": "00:00", "endTime": "00:00"},
            {"dayIdx": 6, "startTime": "00:00", "endTime": "00:00"},
            {"dayIdx": 7, "startTime": "00:00", "endTime": "00:00"}]
      }

      if (!this.vetDoctor.progressiveReservationsDayHoursJsonDashboard) {
        this.progressiveReservationsDayHoursDashboardArray = this.prepareProgressiveReservationsDayHoursDashboardArray();
      } else {
        this.progressiveReservationsDayHoursDashboardArray = JSON.parse(this.vetDoctor.progressiveReservationsDayHoursJsonDashboard);
      }

    }

    this.defaultVisitMinutes = this.vetDoctor.defaultVisitMinutes;
    this.vetDoctorHadDefaultMinutes = !!this.defaultVisitMinutes;
    this.startingDefaultMinutes = this.defaultVisitMinutes;

    if (this.vetDoctor.lockedReservationDayHoursJson) {
      this.lockedReservationDayHoursJson = JSON.parse(this.vetDoctor.lockedReservationDayHoursJson)
    } else {
      this.lockedReservationDayHoursJson =
        [{"dayIdx": 1, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 2, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 3, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 4, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 5, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 6, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 7, "startTime": "00:00", "endTime": "00:00"}]
    }

    if (!this.vetDoctor.lockedReservationDayHoursJsonDashboard) {
      this.lockedReservationDayHoursJsonArray = this.prepareLockedReservationsDayHoursDashboardArray();
    } else {
      this.lockedReservationDayHoursJsonArray = JSON.parse(this.vetDoctor.lockedReservationDayHoursJsonDashboard);
    }

    if (this.vetDoctor.nightShiftLock) {
      if (this.vetDoctor.nightShiftLockHourDaysJsonDashboard) {
        this.nightShiftLockHourDaysJsonDashboardArray = JSON.parse(this.vetDoctor.nightShiftLockHourDaysJsonDashboard)
      } else {
        this.nightShiftLockHourDaysJsonDashboardArray =
          [{"dayIdx": 1, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
            {"dayIdx": 2, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
            {"dayIdx": 3, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
            {"dayIdx": 4, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
            {"dayIdx": 5, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
            {"dayIdx": 6, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
            {"dayIdx": 7, "startTime": "00:00", "endTime": "00:00", "isFullDay": false}]
      }
    }

    if (this.vetDoctor.medicalProcedureCancellationTime) {
      this.medicalProcedureCancellationTime = `${this.vetDoctor.medicalProcedureCancellationTime}`;
    } else {
      this.medicalProcedureCancellationTime = 'none';
    }

    if (!this.vetDoctor.phoneOnlyReservationDaysJson || this.vetDoctor.phoneOnlyReservationDaysJson == '[]') {
      this.phoneOnlyDays =
        [{"dayIdx": 1, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 2, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 3, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 4, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 5, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 6, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 7, "startTime": null, "endTime": null, "isFullDay": false}]
    } else {
      this.phoneOnlyDays = this.preparePhoneOnlyDays(this.vetDoctor.phoneOnlyReservationDaysJson);
    }

    if (!this.vetDoctor.stationaryReservationDaysJson || this.vetDoctor.stationaryReservationDaysJson == '[]') {
      this.stationaryOnlyDays =
        [{"dayIdx": 1, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 2, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 3, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 4, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 5, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 6, "startTime": null, "endTime": null, "isFullDay": false},
          {"dayIdx": 7, "startTime": null, "endTime": null, "isFullDay": false}]
    } else {
      this.stationaryOnlyDays = this.prepareStationaryOnlyDays(this.vetDoctor.stationaryReservationDaysJson);
    }

    if (this.vetDoctor.advancedLockedDayHoursJson) {
      this.advancedLockedDayHoursArray = JSON.parse(this.vetDoctor.advancedLockedDayHoursJson);
    }

    this.vetDocInfoGroup = this.formBuilder
      .group({
        prepaidRequired: [this.vetDoctor.prepaidRequired],
        prepaidVisitPrice: [this.vetDoctor.prepaidVisitPrice, Validators.pattern(environment.PRICE_REGEXP_PATTERN)],
        description: [this.vetDoctor.description],
        photoImageUUID: [this.vetDoctor.photoImageUUID],
        largePhotoImageUUID: [this.vetDoctor.largePhotoImageUUID],
        orderIndex: [this.vetDoctor.orderIndex],
        progressiveReservations: [this.vetDoctor.progressiveReservations],
        nightShiftLock: [this.vetDoctor.nightShiftLock],
        lowerReservationsLimit: [this.vetDoctor.lowerReservationsLimit],
        upperReservationsLimit: [this.vetDoctor.upperReservationsLimit],
        maxHoleSize: [this.vetDoctor.maxHoleSize]
      });

    this.vImagesSub = this.fileService.getVImages(false, this.vetcodeId.toString()).subscribe(images => {
      this.vImages = images;
    });

    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
      if (isBusy) {
        this.vetDocInfoGroup.disable();
      } else {
        this.vetDocInfoGroup.enable();

      }
    });
  }

  onSave() {
    if (this.advancedDaysBlockedToggle) {
      if (!this.checkAllAdvancedDaySettingsAreCorrect()) {
        this.commonUtils.presentAlertToast('Popraw ustawienia zaawansowanych blokad rezerwacji');
        return;
      }
    }

    this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
      const vetDoctorEdited: VetDoctor = this.commonUtils.formGroupValuesToObject<VetDoctor>(new VetDoctor(), this.vetDocInfoGroup);
      this.appStateService.updateIsBusySubject(true);
      vetDoctorEdited.description = this.textAreaValue;

      vetDoctorEdited.uuid = this.vetDoctor.uuid;

      vetDoctorEdited.photoImageUUID = this.vetDoctor.photoImageUUID;
      vetDoctorEdited.largePhotoImageUUID = this.vetDoctor.largePhotoImageUUID;
      if (vetDoctorEdited.progressiveReservations && this.vetDoctor.progressiveReservationsDayHoursJsonDashboard) {
        vetDoctorEdited.progressiveReservationsDayHoursJsonDashboard = this.vetDoctor.progressiveReservationsDayHoursJsonDashboard;
        vetDoctorEdited.progressiveReservationsDaysJson = JSON.stringify(this.progressiveReservationsDayHoursDashboardArray
          .filter(e => e.startTime !== e.endTime || e.isFullDay)
          .map(e => e.dayIdx));
        vetDoctorEdited.progressiveReservationsDayHoursJson = JSON.stringify(this.progressiveReservationsDayHoursDashboardArray
          .filter(e => !e.isFullDay)
          .map(e => {
            let obj = new ReservationDhJson();
            obj.dayIdx = e.dayIdx;
            obj.endTime = e.endTime;
            obj.startTime = e.startTime;
            return obj;
          }));
      }

      if (this.vetDoctor.lockedReservationDayHoursJsonDashboard) {
        vetDoctorEdited.lockedReservationDayHoursJsonDashboard = this.vetDoctor.lockedReservationDayHoursJsonDashboard;
        vetDoctorEdited.lockedReservationDaysJson = JSON.stringify(this.lockedReservationDayHoursJsonArray
          .filter(e => e.isFullDay)
          .map(e => e.dayIdx));
        vetDoctorEdited.lockedReservationDayHoursJson = JSON.stringify(this.lockedReservationDayHoursJsonArray
          .filter(e => !e.isFullDay)
          .map(e => {
            let obj = new ReservationDhJson();
            obj.dayIdx = e.dayIdx;
            obj.endTime = e.endTime;
            obj.startTime = e.startTime;
            return obj;
          }));
      }

      if (this.vetDoctor.nightShiftLockHourDaysJsonDashboard) {
        vetDoctorEdited.nightShiftLockHourDaysJsonDashboard = this.vetDoctor.nightShiftLockHourDaysJsonDashboard;
        // console.log(this.vetDoctor.nightShiftLockHourDaysJsonDashboard)
        // vetDoctorEdited.nightShiftLockHourDaysJsonDashboard = JSON.stringify(this.nightShiftLockHourDaysJsonDashboardArray
        //   .filter(e => !e.isFullDay)
        //   .map(e => {
        //     let obj = new ReservationDhJson();
        //     obj.dayIdx = e.dayIdx;
        //     obj.endTime = e.endTime;
        //     obj.startTime = e.startTime;
        //     return obj;
        //   }));
      }

      if (this.phoneOnlyDays) {
        vetDoctorEdited.phoneOnlyReservationDaysJson = JSON.stringify(this.phoneOnlyDays
          .filter(e => e.isFullDay)
          .map(e => e.dayIdx));
      }

      if (this.stationaryOnlyDays) {
        vetDoctorEdited.stationaryReservationDaysJson = JSON.stringify(this.stationaryOnlyDays
          .filter(e => e.isFullDay)
          .map(e => e.dayIdx));
      }

      vetDoctorEdited.advancedLockedDayHoursJson = JSON.stringify(this.advancedLockedDayHoursArray);
      vetDoctorEdited.defaultVisitMinutes = this.defaultVisitMinutes;
      vetDoctorEdited.onlineReservationDisabled = this.vetDoctor.onlineReservationDisabled;


      if (this.medicalProcedureCancellationTime && this.medicalProcedureCancellationTime !== 'none') {
        vetDoctorEdited.medicalProcedureCancellationTime = Number.parseInt(this.medicalProcedureCancellationTime);
      }

      if (!this.medicalProcedureCancellationTime || this.medicalProcedureCancellationTime === 'none') {
        vetDoctorEdited.medicalProcedureCancellationTime = null;
      }


      this.vetClinicService.updateVetDoctor(vetDoctorEdited)
        .subscribe((vetDoctor: VetDoctor) => {
            this.appStateService.updateIsBusySubject(false);

            this.commonUtils.presentInfoToast("Pracownik został zmieniony").then(res => {
              this.vetDoctorEditedEmitter.emit(vetDoctor);
            });
            this.hasUnsavedChanges = false;
          },
          error => {
            this.appStateService.updateIsBusySubject(false);

            this.commonUtils.presentAlertToast("Wystąpił błąd podczas zmiany pracownika");
          });
    }, () => {
      this.appStateService.updateIsBusySubject(false);
    });
  }

  onDocPictureChanged(formGroup: FormGroup, vImage: VImage) {
    if (vImage) {
      formGroup.get('photoImageId').setValue(vImage.uuid);
    }
  }

  onDocPictureChangedSetLarge(formGroup: FormGroup, vImage: VImage) {
    if (vImage) {
      formGroup.get('largePhotoImageId').setValue(vImage.uuid);
    }
  }

  onCancelEdit() {
    if (this.hasUnsavedChanges || this.images?.length > 0) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z zapisu?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.vetDoctorEditCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.vetDoctorEditCanceledEmitter.emit(true);
    }
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
      this.hasUnsavedChangesEmitter.emit(true);
    }
  }

  async openImageDropForPhoto(formControlName: 'photoImageUUID' | 'largePhotoImageUUID', imageFolder: string) {
    const modal = await this.modalController.create({
      component: VImageDropComponent,
      componentProps: {
        'multiple': false,
        'vetClinicUUID': this.vetClinicUUID,
        'imageFolder': imageFolder
      }
    });

    modal.onDidDismiss<VImage>().then((dismissData) => {
      if (dismissData && dismissData.data !== undefined && dismissData.data != null) {
        if (formControlName === 'photoImageUUID') {
          this.vetDoctor.photo = dismissData.data;
          this.vetDoctor.photoImageUUID = dismissData.data.uuid;
        } else if (formControlName === 'largePhotoImageUUID') {
          this.vetDoctor.largePhoto = dismissData.data;
          this.vetDoctor.largePhotoImageUUID = dismissData.data.uuid;
        }

        if (this.images) {
          this.images.push(dismissData.data)
        } else {
          this.images = [];
          this.images.push(dismissData.data)
        }

        this.vetDocInfoGroup.get(formControlName).setValue(dismissData.data?.uuid);
        this.markUnsavedChanges();
      }
    });

    return await modal.present();
  }

  getImageSrcById(imgUUID: string, width) {
    if (this.vImages) {
      return this.commonUtils.getVImageUrlPath(this.vetClinicUUID, width, this.vImages.find(({uuid}) => uuid === imgUUID));
    }
  }

  log() {
    let vetDoctorEdited: VetDoctor = this.commonUtils.formGroupValuesToObject<VetDoctor>(new VetDoctor(), this.vetDocInfoGroup);
    console.log(vetDoctorEdited);
  }

  revertImage(valueToRevert: string, image: VImage) {
    if (valueToRevert === 'largePhoto') {
      this.vetDoctor.largePhoto = this.vetDocCp.largePhoto;
      this.vetDoctor.largePhotoImageUUID = this.vetDocCp.largePhotoImageUUID;
    }
    if (valueToRevert === 'photo') {
      this.vetDoctor.photo = this.vetDocCp.photo;
      this.vetDoctor.photoImageUUID = this.vetDocCp.photoImageUUID;

    }
    if (this.images) {
      this.images = this.images.filter(e => e.uuid !== image.uuid);
    }
  }

  ngOnDestroy() {
    console.log('doctor-edit destroyed');
    if (this.vImagesSub) {
      this.vImagesSub.unsubscribe();
    }
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
  }

  onChangeProgressiveReservations($event) {
    this.vetDoctor.progressiveReservations = $event.detail.checked;
    if (this.vetDoctor.progressiveReservationsDayHoursJson) {
      this.progressiveReservationsDayHoursJson = JSON.parse(this.vetDoctor.progressiveReservationsDayHoursJson)
    } else {
      this.progressiveReservationsDayHoursJson =
        [{"dayIdx": 1, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 2, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 3, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 4, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 5, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 6, "startTime": "00:00", "endTime": "00:00"},
          {"dayIdx": 7, "startTime": "00:00", "endTime": "00:00"}]
    }

    if (!this.vetDoctor.progressiveReservationsDayHoursJsonDashboard) {
      this.progressiveReservationsDayHoursDashboardArray = this.prepareProgressiveReservationsDayHoursDashboardArray();
    } else {
      this.progressiveReservationsDayHoursDashboardArray = JSON.parse(this.vetDoctor.progressiveReservationsDayHoursJsonDashboard);
    }

  }

  onEditProgressiveReservationsDayHourJson(resJson: ReservationDhJsonDashboard[]) {
    this.progressiveReservationsDayHoursDashboardArray = resJson;
    this.vetDoctor.progressiveReservationsDayHoursJsonDashboard = JSON.stringify(resJson);
  }

  onEditLockReservationsDayHourJson(resJson: ReservationDhJsonDashboard[]) {
    this.lockedReservationDayHoursJsonArray = resJson;
    this.vetDoctor.lockedReservationDayHoursJsonDashboard = JSON.stringify(resJson);
  }

  onEditAdvancedSettingsDayHourJson(daysSettings: DaySettings[]) {
    this.advancedLockedDayHoursArray = daysSettings;
    this.vetDoctor.advancedLockedDayHoursJson = JSON.stringify(daysSettings);
  }

  private prepareProgressiveReservationsDayHoursDashboardArray() {
    let hdArray = this.progressiveReservationsDayHoursJson;
    if (this.vetDoctor.progressiveReservationsDaysJson) {
      return hdArray.map(e => {
        let obj = new ReservationDhJsonDashboard();
        obj.dayIdx = e.dayIdx;
        obj.startTime = e.startTime;
        obj.endTime = e.endTime;
        if ((JSON.parse(this.vetDoctor.progressiveReservationsDaysJson) as number[]).includes(e.dayIdx)) {
          obj.isFullDay = true;
        } else {
          obj.isFullDay = false;
        }
        return obj;
      })
    } else {
      return hdArray.map(e => {
        let obj = new ReservationDhJsonDashboard();
        obj.dayIdx = e.dayIdx;
        obj.startTime = e.startTime;
        obj.endTime = e.endTime;
        obj.isFullDay = false;
        return obj;
      })
    }
  }

  onChangeNightShiftLock($event) {
    this.vetDoctor.nightShiftLock = $event.detail.checked;

    if (this.vetDoctor.nightShiftLockHourDaysJsonDashboard) {
      this.nightShiftLockHourDaysJsonDashboardArray = JSON.parse(this.vetDoctor.nightShiftLockHourDaysJsonDashboard)
    } else {
      this.nightShiftLockHourDaysJsonDashboardArray =
        [{"dayIdx": 1, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
          {"dayIdx": 2, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
          {"dayIdx": 3, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
          {"dayIdx": 4, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
          {"dayIdx": 5, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
          {"dayIdx": 6, "startTime": "00:00", "endTime": "00:00", "isFullDay": false},
          {"dayIdx": 7, "startTime": "00:00", "endTime": "00:00", "isFullDay": false}]
    }
  }

  onEditNightShiftReservationsDayHourJson(resJson: ReservationDhJsonDashboard[]) {
    this.vetDoctor.nightShiftLockHourDaysJsonDashboard = JSON.stringify(resJson);
  }

  private preparePhoneOnlyDays(phoneOnlyReservationDaysJson: string) {
    let arrayOfDays = JSON.parse(phoneOnlyReservationDaysJson) as number[];
    return [{"dayIdx": 1, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(1)},
      {"dayIdx": 2, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(2)},
      {"dayIdx": 3, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(3)},
      {"dayIdx": 4, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(4)},
      {"dayIdx": 5, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(5)},
      {"dayIdx": 6, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(6)},
      {"dayIdx": 7, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(7)}]

  }

  onEditPhoneOnlyDays(obj: ReservationDhJsonDashboard[]) {
    console.log(obj)
    this.phoneOnlyDays = obj;
  }

  onEditStationaryOnlyDays(obj: ReservationDhJsonDashboard[]) {
    this.stationaryOnlyDays = obj;
  }


  private prepareStationaryOnlyDays(stationaryReservationDaysJson: string) {
    let arrayOfDays = JSON.parse(stationaryReservationDaysJson) as number[];
    return [{"dayIdx": 1, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(1)},
      {"dayIdx": 2, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(2)},
      {"dayIdx": 3, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(3)},
      {"dayIdx": 4, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(4)},
      {"dayIdx": 5, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(5)},
      {"dayIdx": 6, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(6)},
      {"dayIdx": 7, "startTime": null, "endTime": null, "isFullDay": arrayOfDays.includes(7)}]
  }

  private prepareLockedReservationsDayHoursDashboardArray() {
    let hdArray = this.lockedReservationDayHoursJson;
    if (this.vetDoctor.lockedReservationDayHoursJson) {
      return hdArray.map(e => {
        let obj = new ReservationDhJsonDashboard();
        obj.dayIdx = e.dayIdx;
        obj.startTime = e.startTime;
        obj.endTime = e.endTime;
        if ((JSON.parse(this.vetDoctor.lockedReservationDayHoursJson) as number[]).includes(e.dayIdx)) {
          obj.isFullDay = true;
        } else {
          obj.isFullDay = false;
        }
        return obj;
      })
    } else {
      return hdArray.map(e => {
        let obj = new ReservationDhJsonDashboard();
        obj.dayIdx = e.dayIdx;
        obj.startTime = e.startTime;
        obj.endTime = e.endTime;
        obj.isFullDay = false;
        return obj;
      })
    }
  }

  disable() {
    this.appStateService.updateIsBusySubject(!this.isBusy)
  }

  getTitle() {
    return `Edycja zespołu: ${this.vetDoctor.name}`;
  }

  toggleProgressiveLockSettings() {
    this.progressiveLockSettings = !this.progressiveLockSettings;
  }

  toggleNightShiftLockSettings() {
    this.nightShiftLockSettings = !this.nightShiftLockSettings;
  }

  togglePhoneOnlyDaysSettings() {
    this.phoneOnlyDaysToggle = !this.phoneOnlyDaysToggle;
  }

  toggleStationaryOnlyDaysSettings() {
    this.stationaryOnlyDaysToggle = !this.stationaryOnlyDaysToggle;
  }

  toggleDaysBlockedSettings() {
    this.daysBlockedToggle = !this.daysBlockedToggle;
  }

  toggleAdvancedBlockedSettings() {
    this.advancedDaysBlockedToggle = !this.advancedDaysBlockedToggle;
  }

  changedEditor($event: any) {
    if ($event.html) {
      this.textAreaValue = $event.html.replace(new RegExp(/<p><br[\/]?><[\/]?p>/g), '<br>');
      const lines = this.textAreaValue.split('</p>');
      this.textAreaValue = lines.join('</p>\n');
      this.textAreaValue = this.textAreaValue.replace(new RegExp('\n$'), '');
      this.textAreaValueToSave = this.textAreaValue;

    }
    if ($event.event === 'text-change') {
      this.markUnsavedChanges();
      this.vetDocInfoGroup.controls.description.markAsTouched();
    }
  }

  onHTMLToggle($event) {
    this.isHTMLToggle = $event.detail.checked;
  }

  textAreaChange($event) {
    this.textAreaValue = $event.detail.value;
  }

  onSaveHTML() {
    this.vetDocInfoGroup.controls.description.setValue(this.textAreaValue);
  }

  onEditorCreated() {
    this.quill = this.editor.quillEditor;
    if (this.vetDoctor.description) {
      this.textAreaValue = this.vetDoctor.description;
      this.textAreaValueToSave = this.textAreaValue;
    }
  }

  private checkAllAdvancedDaySettingsAreCorrect() {
    return !this.advancedLockedDayHoursArray.map(daySettings => {
      return !!(daySettings.isFullDay || (!daySettings.isFullDay && daySettings.startTime && daySettings.endTime));
    }).includes(false);
  }

  deleteDoctor() {
    this.commonUtils.presentYesNoActionSheet('Usunięcie tego pracownika skutkuje skasowaniem wszystkich zdjęć, ustawień, opisów oraz powiązań. Czy na pewno chcesz usunąć tego pracownika?  ', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
      this.appStateService.updateIsBusySubject(true);
      this.vetClinicService.deleteDoctor(this.vetDoctor.uuid).subscribe(e => {
        if (e && e == 'DOCTOR_REMOVED') {
          this.vetDoctorDeletedEmitter.emit(true);
        } else {
          this.commonUtils.presentAlertToast('Usunięcie pracownika nie powiodło się. Sprawdź, czy nie posiada on przypisanych typów wizyt.');
        }
        this.appStateService.updateIsBusySubject(false);
      }, error => {
        this.commonUtils.presentAlertToast('Usunięcie pracownika nie powiodło się. Sprawdź, czy nie posiada on przypisanych typów wizyt.');
        this.appStateService.updateIsBusySubject(false);
      })
    }, () => {
    });

  }
}

